define(['jquery', 'postalhelper', 'forms'], function ($, ERVPostalHelper, ERVForms) {
	var ERVHealthDeclaration = function() {
		var self = this;

		self.$ervBody = $('#erv-body');
		self.$form = $('form[data-js-mainform]');
		self.postalHelper = new ERVPostalHelper();
		self.forms = new ERVForms();
	};

	ERVHealthDeclaration.prototype.init = function () {
		var self = this;

		self.postalHelper.init();

		self.forms.setupRadioTogglers(self.$form.find('*[data-js="yes-toggler"]'), '.question-container');
	}

	return ERVHealthDeclaration;
});